import axios from '@axios'

export default {
    namespaced: true,
    state: {
        roles: [],
        rutas: [],
        shortcuts: [],

    },
    getters: {
        getRoles(state) {
            return state.roles
        },
        getRutas(state) {
            return state.rutas
        },
        getShortcuts(state) {
            return state.shortcuts
        },
    },
    mutations: {
        setRoles(state, roles) {
            state.roles = roles
        },
        setRutas(state, rutas) {
            state.rutas = rutas
        },
        setShortcuts(state, shortcuts) {
            state.shortcuts = shortcuts
        },
    },
    actions: {
        crearUsuario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/usuarios/crearUsuario', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchRoles({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/usuarios/roles')
                    .then((response) => {
                        commit('setRoles', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchRutas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/usuarios/rutas')
                    .then((response) => {
                        commit('setRutas', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        updateShortcuts({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/usuarios/shortcuts', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchShortcuts({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/usuarios/getShortcuts')
                    .then((response) => {
                        commit('setShortcuts', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        }
    },
}